import type { TrainingLocation } from '@/api/types/enrollment'

export interface WebinarTimeZoneDisplay {
  code: string
  abbreviation: string
  scheduledStartTime: string
  scheduledStartHour: number
  scheduledStartMinute: number
  dayPart?: string
}

export interface WebinarEvent {
  id: number
  title?: string
  publicUrl: string
  scheduledStartAt: string
  scheduledEndAt?: string
  status?: string
  timeZoneDisplays?: WebinarTimeZoneDisplay[]
}

export interface TimeSlotSelection {
  time: string
  rawTime: string
  type: 'inPerson' | 'phone' | 'online'
  eventId?: number
  eventUrl?: string
  scheduledStartAt?: string
}

export interface RegisteredOnlineSession {
  date: string
  time: string
}

export interface AppointmentContactData {
  contactExternalId: string
  email: string
  firstName: string
  lastName: string
  phoneNumber: string
}

export interface LocationOption {
  label: string
  value: string
}

export interface OnlineSessionRow {
  rawTime: string
  time: string
  event: WebinarEvent
}

export const toLocationOption = (location: TrainingLocation): LocationOption => ({
  label: [location.name, [location.city, location.state].filter(Boolean).join(', ')]
    .filter(Boolean)
    .join(' - '),
  value: String(location.externalId || location.id)
})
